import { CONSUMER } from '../constants';
// This function is used to provide error messages to the user that are
// different than the error messages provided by the SDK.
export default function enhanceMessage(message = '', code, isMobile, source) {  
    if (message && !code)
        return message;
    else {
        switch (code) {
            case "NotFoundError":
                return "We couldn't find your camera and microphone. Make sure they're not blocked by anti-virus software, they're connected properly, and your drivers are up to date.";
            case "NotAllowedError":
                if (isMobile) {
                    return "Your camera and microphone are blocked. Verify MyBSWHealth has access to your camera and microphone in your Settings.";
                } else {
                   return "Your camera and microphone are blocked. Click the camera icon in the URL bar above to give MyBSWHealth access to your computer's camera and microphone.";
                }
            case "NotReadableError":
                return "Your camera or microphone is already in use by another application. Close the other application and try again.";
            case "OverconstrainedError":
                return "A supported camera or microphone could not be found.";
            case 53000:
            case 53204:
                return source === CONSUMER ? "We were unable to establish a connection." : "We were unable to establish a connection. Please try again.";
            case 53006:
                return "We were unable to establish a connection. Please try again.";
            case 53105:
                return "The room is full. No additional participants are allowed.";
            case 53106:
                return "The requested room cannot be found.";
            case 53118:
                return "The requested room is no longer available.";
            case 53205:
                return "You've been disconnected. A person with the same name has joined the room.";
            case 53405:
                return source === CONSUMER ? "We're unable to rejoin the room." : "We're unable to rejoin the room. Please try again.";
            case 53001:
                return "We were unable to rejoin the room due to internet issues.";
            case 20103:
            case 20104:
            case 20107:
            case 20151:
            case 20105:
            case 20157:
                return "The requested room is no longer available.";
            default:
                return "We were unable to begin the video visit. Please try again.";
        }
    }
}